import styled from 'styled-components';

export const TabGroup = styled.div`
    position: absolute;
    background-color: #111;
    border-left: 1px solid #333;
    width: 430px;
    top: 0;
    bottom: 0;
    right: 1px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    jsutify-content: stretch;
    box-shadow: 0 3px 5px rgba(0,0,0,0.4);
`;

export const TabList = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin-top: 10px;
`;

export const Tab = styled.div`
    border: 1px solid #333;
    padding: 2px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background-color: #333;
    color: #999;
    margin-right: 1px;
    font-size: 12px;
    position: relative;
    z-index: 1;

    &.active {
        z-index: 3;
        color: #fff;
        background-color: #444;
        border: 1px solid #444;
    }

    &.hidden {
        display: none;
    }
`;

export const TabContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    height: 100%;
    color: #fff;
    margin-top: -1px;
    position: relative;
    z-index: 2;
    border-top: 1px solid #444;
    flex: 1;
`;

export const TabData = styled.div`
    display: none;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    width: 100%;
    height: 100%;
    color: #fff;
    flex: 1;

    &.active {
        display: flex;
    }
`;